import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body, #root {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  body {
    font-family: 'Roboto', sans-serif;
    margin: 0;
    background: #f4f6f8;
    overflow-x: auto;
    min-width: 1130px;
}

.react-pdf__Document {
    display: contents;
    align-items: center;
    padding: 16px;
    background: #e0e0e0;
    margin: 0 auto;
    margin-bottom: 52px;
}

.document_separator {
    width: 28px;
    margin-left: 28px;
    display: flex;
    justify-content: center;
    cursor: pointer;
}

.react-pdf__Page__textContent {
  display: none;
}

.MuiTooltip-tooltip {
  background: rgba(97, 97, 97, 0.9);
  font-size: 10px;
}
`;

export default GlobalStyle;
